<!--
 * @Author: CRS
 * @Date: 2024-11-06 09:52:04
 * @Descripttion: 入班审核
-->
<template>
  <Dialog class="cusBody" title="入班审核" width="980px" top="8vh" :modal="true" :visible.sync="status">
    <div class="flex-v">
      <div class="flex">
        <div class="layout-right pd" style="width: 100%;">
          <ScrollBar ref="scrollbar" class="scrollbar main">
            <div class="vfWrap">
              <Form :inline="true" :model="form" class="demo-form-inline">
                <FormItem label="申请身份">
                  <Select v-model="form.type" placeholder="申请身份" @change="getVerifyList" clearable>
                    <Option label="全部" :value="0"></Option>
                    <Option label="老师" :value="1"></Option>
                    <Option label="学生" :value="2"></Option>
                  </Select>
                </FormItem>
                <FormItem label="申请加入学校" style="margin-left: 30px;">
                  <Select v-model="form.school" placeholder="申请加入学校" filterable clearable @change="getVerifyList">
                    <Option :label="name" :value="name" v-for="name in schoolList" :key="name"></Option>
                  </Select>
                </FormItem>
              </Form>
              <ul class="flex">
                <li v-for="head in tableHead" :key="head.key" class="liItem head" :class="head.key">
                  {{ head.text }}
                </li>
                <li class="liItem head">操作</li>
              </ul>
              <ul class="hideScrollbar">
                <li class=" flex" v-for="(item, idx) in applyList">
                  <div v-for="head in tableHead" class="txt line1 liItem" :class="head.key">{{ head.key === 'identity' ?
                    ['教师', '学生'][item[head.key] - 1] : item[head.key] }}</div>
                  <div class="txt liItem flex-center dishBtn">
                    <span @click.stop="onApply(item.id, 2)">拒绝</span>
                    <span class="pass" @click.stop="onApply(item.id, 1)">通过</span>
                  </div>
                </li>
                <Empty class="noData" title="暂无数据 ~" v-if="isSpace"></Empty>
              </ul>
            </div>
          </ScrollBar>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import {
  Dialog, Form,
  FormItem, Select, Option
} from "element-ui";
import Empty from "business/Empty";
import util from "libs/util";
export default {
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Empty
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: -1,
      status: false,
      isSpace: false,
      form: {},
      schoolList: [],
      applyList: [],
      tableHead: Object.freeze([
        {
          text: '邀请人',
          key: 'inviteName',
        },
        {

          text: '申请身份',
          key: 'identity',
        },
        {

          text: '申请用户名',
          key: 'name',
        },
        {

          text: '申请加入学校',
          key: 'schoolName',
        },
        {

          text: '申请加入班级',
          key: 'classesName',
        },
        {

          text: '申请加入时间',
          key: 'applyTime',
        },
      ])
    }
  },
  mounted() {
    if(localStorage.getItem('LLSS_TOKEN'))this.getVerifyList()
  },
  methods: {
    getVerifyList() {
      this.$post('/classes/classesApplyList.json', this.form).then(res => {
        const list = res.data || [];
        list.forEach((item) => {
          item.classesName = item.classesName?.includes('年级') ? item.classesName :( util.gradeNumToText(item.grade) + item.classesName);
        });
        this.applyList = list;
        this.isSpace = !this.applyList.length;
        this.$emit('onCount',this.applyList.length);
      })
    },
    loadSchools() {
      this.$post('/classes/schoolList.json', {}).then(res => {
        this.schoolList = res.data || [];
      })
    },
    // 入班审核
    async onApply(id, type) {
      try {
        const res = await this.$post('/classes/passOrRefuseClassesApply.json', {
          id,
          type //	1=通过 2=拒绝
        })
        this.$toast('操作成功');
        this.getVerifyList();
      } catch (error) {

      }
    }
  },
  watch: {
    status(val) {
      if (val) {
        this.form = {
          type: 0,
          school: null
        }
        if(!this.schoolList.length)this.loadSchools();
        this.getVerifyList()
      }
    }
  }
}
</script>


<style lang="less" scoped>
@import '~styles/book/detail.less';

.vfWrap {
  padding: 24px 40px 0;

  ul {
    max-height: 450px;
    overflow: auto;
    cursor: pointer;
    &.hideScrollbar {
      min-height: 300px;
    }

    .liItem {
      flex: 1;
      overflow: auto;
      text-align: center;
      font-size: 12px;
      color: #333;

      &.schoolName {
        flex: 2;
      }

      &.head {
        height: 24px;
        line-height: 24px;
        background: rgba(255, 255, 255, 0.8);
        color: #666666;
      }

      &.txt {
        padding: 16px 0;
      }
    }

    li {
      background: #fff;

      &:nth-child(2n+1) {
        background: #F6FEFF;
      }
    }

    .dishBtn {
      color: #DA9C75;
      font-weight: bold;

      .pass {
        color: #FB7C33;
        margin-left: 30px;
      }
    }
  }

  .noData {
    padding-top: 50px;
  }
}
</style>